module.exports = __webpack_public_path__ + "img/6ec5eac44f0c5d37c71512c30dd7fcde.png";